import api from 'data/api';

export const loadColumns = api('GET /api/mobile/performance/columns');
